import React from 'react';
import cx from 'classnames';
import { Grid, Row, Col, Image } from 'react-bootstrap';
import { localizedStrings } from 'src/localization/index.jsx';
import Button from 'src/components/button/index';
import styles from './dataSourceDeleteView.module.scss';

class DataSourceMigrateView extends React.Component {
  constructor(props) {
    super(props);

    this._handleMigrateClick = this._handleMigrateClick.bind(this);
    this._handleCancelClick = this._handleCancelClick.bind(this);

    this.localizedCommons = localizedStrings.commons;
    this.localizedCommonLoading = this.localizedCommons.loading;
    this.localizedCommonActions = this.localizedCommons.actions;
    this.localizedSettings = localizedStrings.pages.settings;
    this.localizedContentSources = this.localizedSettings.content_sources;
    this.localizedMigrateSlider = this.localizedContentSources.sliders.migrate;
  }

  _handleMigrateClick() {
    if (this.props.onMigrate) {
      this.props.onMigrate();
    }
  }

  _handleCancelClick() {
    if (this.props.onCancel) {
      this.props.onCancel();
    }
  }

  render() {
    return (
      <div className={styles.content}>
        <Row className={styles.top}>
          <h1 className={styles.heading}>{this.localizedMigrateSlider.title}</h1>

          {/* <p className={styles.description}>
            Are you sure you want to migrate {this.props.name} source? {this.props.assets} assets will be migrated, this step cannot be undone.
          </p> */}
          <p className={styles.description}>
          {this.localizedMigrateSlider.heading}
          </p>

          <ul style={{paddingLeft:'20px'}}>
           <li className={styles.description}>{this.localizedMigrateSlider.description.note_one}</li>
           <li className={styles.description}>{this.localizedMigrateSlider.description.note_two}</li>
           <li className={styles.description}>{this.localizedMigrateSlider.description.note_three}</li>
          </ul>

          <div className={styles.buttonTray}>
            <Button
              text={this.localizedCommonActions.confirm}
              variant='primary'
              className={styles.send}
              onClick={() => { this._handleMigrateClick() }}
              icon='paperflite-tick'
            >
            </Button>
            <Button
              text={this.localizedCommonActions.cancel}
              variant='secondary'
              className={styles.cancel}
              onClick={() => { this._handleCancelClick() }}
            >
            </Button>
          </div>
        </Row>
      </div>
    );
  }

}
export default DataSourceMigrateView;
